import { testimonials } from "@/lib/testimonials";
import { Star, Quote } from "lucide-react";

// Trust strip near the booking CTA — reuses the real, curated client testimonials
// (same source as the homepage & /testimonials). No seeded/placeholder reviews.
export function BookingSocialProof() {
  const items = testimonials.slice(0, 3);
  if (items.length === 0) return null;

  return (
    <div className="mb-10" data-testid="booking-social-proof">
      <div className="flex items-center gap-2 mb-4">
        <div className="flex gap-0.5">
          {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-4 w-4 fill-[#FF331F] text-[#FF331F]" />)}
        </div>
        <span className="text-sm text-zinc-300 font-semibold">What athletes say about training with Coach Chris</span>
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        {items.map((t, i) => (
          <div key={i} className="border border-[#27272A] bg-[#0F0F0F] p-4" data-testid={`social-proof-${i}`}>
            <Quote className="h-4 w-4 text-[#FF331F] mb-2" />
            <p className="text-sm text-zinc-200 leading-snug line-clamp-4">&ldquo;{t.quote}&rdquo;</p>
            <div className="text-[11px] uppercase tracking-widest text-zinc-500 mt-3">— {t.author}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
